var Clipboard, ZeroClipboard, attachCopy, clip, copyHandlers, setupClipboard, setupClipboardJS, setupPromise, setupZeroClipboard, sprintf, ui, unclip;

if (global.jQuery == null) {
  global.jQuery = require('jquery');
}

require('bootstrap/js/modal');

Clipboard = require('clipboard');

ZeroClipboard = require('zeroclipboard');

sprintf = (require('sprintf-js')).sprintf;

ui = require('evesrp/common-ui');

setupPromise = null;

setupClipboard = function() {
  var zClient;
  if (setupPromise !== null) {
    return setupPromise;
  }
  setupPromise = jQuery.Deferred();
  if (!document.queryCommandSupported('copy')) {
    zClient = setupZeroClipboard();
    zClient.on('error', function(ev) {
      return setupClipboardJS();
    });
    zClient.on('ready', function(ev) {
      zClient.on('copy', function(copyEvent) {
        var handler, i, len, results;
        results = [];
        for (i = 0, len = copyHandlers.length; i < len; i++) {
          handler = copyHandlers[i];
          results.push(handler(copyEvent));
        }
        return results;
      });
      return setupPromise.resolve();
    });
  } else {
    setupClipboardJS();
  }
  return setupPromise;
};

setupZeroClipboard = function() {
  var zClient;
  ZeroClipboard.config({
    swfPath: scriptRoot + "/static/ZeroClipboard.swf"
  });
  zClient = new ZeroClipboard(jQuery('.copy-btn'));
  zClient.on('error', function(ev) {
    zClient.destroy();
    return module.zClient = null;
  });
  module.zClient = zClient;
  return zClient;
};

setupClipboardJS = function() {
  var $copyModal, $document, hideHandler, jClient;
  jClient = new Clipboard('.copy-btn');
  $copyModal = jQuery('#copyModal');
  $document = jQuery(document);
  hideHandler = function(ev) {
    $copyModal.modal('hide');
    return $document.off('copy.evesrp', hideHandler);
  };
  ui.setupTranslations().done(function() {
    var keyCombo, newText, translatedText;
    translatedText = ui.i18n.gettext('Press %(key_combo)s to Copy.');
    if (/Mac/i.test(navigator.userAgent)) {
      keyCombo = '⌘-C';
    } else {
      keyCombo = 'Ctrl-C';
    }
    newText = sprintf(translatedText, {
      key_combo: keyCombo
    });
    return ($copyModal.find('#keyComboMessage')).text(newText);
  });
  jClient.on('error', function(ev) {
    $copyModal.modal();
    return $document.on('copy.evesrp', hideHandler);
  });
  jClient.on('error', function(ev) {
    var handler, i, len, results;
    results = [];
    for (i = 0, len = copyHandlers.length; i < len; i++) {
      handler = copyHandlers[i];
      results.push(handler(ev));
    }
    return results;
  });
  jClient.on('success', function(ev) {
    var handler, i, len, results;
    results = [];
    for (i = 0, len = copyHandlers.length; i < len; i++) {
      handler = copyHandlers[i];
      results.push(handler(ev));
    }
    return results;
  });
  module.jClient = jClient;
  return setupPromise.resolve();
};

clip = function(elements) {
  if (module.zClient != null) {
    return module.zClient.clip(elements);
  }
};

unclip = function(elements) {
  if (module.zClient != null) {
    return module.zClient.unclip(elements);
  }
};

copyHandlers = [];

attachCopy = function(handler) {
  return copyHandlers.push(handler);
};

exports.setup = setupClipboard;

exports.clip = clip;

exports.unclip = unclip;

exports.attachCopy = attachCopy;

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
